import i18n from "@/i18n";
import { FooterList, HorizontalFlex, RegularTextS, Space } from "@enxcs/dap-ui-stratos";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import packageJson from "../../../package.json";
import { CustomFooter, CustomLogo, CustomVersionInfo } from "./Footer.styles";
import { useTranslation } from "react-i18next";

const FooterSmartDebrief: FC = () => {
  const year = new Date().getFullYear();
  const navigate = useNavigate();

  const { t } = useTranslation();

  return (
    <CustomFooter id={"layout-footer"}>
      <div onClick={() => navigate(`/${i18n.language}`)}>
        <HorizontalFlex $gap={Space.V8}>
          <CustomLogo scale={0.7} />
        </HorizontalFlex>
      </div>

      <FooterList>
        <li>
          <RegularTextS>© {year} Euronext - </RegularTextS>
          <CustomVersionInfo>
            {t("version")} {packageJson.version}
          </CustomVersionInfo>
        </li>
      </FooterList>
    </CustomFooter>
  );
};

export default FooterSmartDebrief;
